<template>
  <div v-if="presentations.length">
    <div
      v-for="(presentation, index) in presentations"
      :key="index"
      class="lg:flex lg:justify-between pt-2 pb-6 last:border-b-0"
    >
      <div class="w-3/4">
        <span
          class="font-ubuntu text-xl leading-[25px] text-gray-dark"
          v-text="presentation.title"
        />
        <div class="mt-1">
          <div>
            <div v-if="presentation.moderator">
              <span style="font-size: 14px"> {{ $t('author.participan') }}</span>
              <div class="pt-ponientes">
                <Authorsevents :list="presentation.moderator" section="autor" />
              </div>
            </div>
            <div v-if="presentation.speakers">
              <span style="font-size: 14px">{{ $t('author.participan') }}</span>
              <div class="pt-ponientes">
                <span v-for="speaker in presentation.speakers" :key="speaker.slug">
                  <Authorsevents :list="speaker" section="autor" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex lg:flex-col lg:items-start mt-4 lg:mt-0"
        :class="loading === index ? 'lg:w-[175px]' : 'lg:w-[150px]'"
      >
        <button
          v-if="presentation.file"
          class="flex items-center text-2xl lg:mb-2.5"
          type="button"
          @click="
            $store.getters['auth/getByField']('loggedIn') || material
              ? onClickPdf(presentation.file, index, material)
              : redirectLogin(true, presentation.file, index)
          "
        >
          <icon name="pt-file-download" />
          <span class="text-gray hover:underline mx-2 lg:mx-3.5 text-base">
            {{ $t('formation.courses.material.downloadPdf') }}
          </span>
          <icon v-if="loading === index" name="spinner" class="animate-spin" />
        </button>
        <button
          v-if="presentation.start_video_at"
          class="flex items-center ml-1.5 lg:m-0"
          type="button"
          @click="
            $store.getters['auth/getByField']('loggedIn') || material
              ? onClickMultimedia(presentation.start_video_at, index, material)
              : redirectLogin(false, presentation.start_video_at, index)
          "
        >
          <NuxtImg
            v-if="video.url"
            :key="video.source_id"
            class="aspect-video h-8 rounded"
            :title="video.title"
            :src="video.thumbnail_url"
            :alt="video?.title ?? 'video'"
            loading="lazy"
          />
          <span class="text-gray hover:underline text-base mx-2 lg:mx-3.5">
            {{ $t('formation.courses.material.seeVideo') }}
          </span>
          <icon v-if="loading === index" name="spinner" class="animate-spin" />
        </button>
      </div>
    </div>
    <ClientOnly>
      <modal-wrapper name="errorFileDownload" width="700">
        <Confirm :message="message" />
      </modal-wrapper>
    </ClientOnly>
    <Player ref="videoPlayerMaterial" :id-player="`sessions-material-${idPlayer}`" />
  </div>
</template>

<script>
import Authorsevents from '@/components/Authors/events';
import { localStorageGetObject } from '~/utils/helpers/store';
import Player from '@/components/VideoLibrary/Player';
import Confirm from '@/components/Profile/Confirm';

export default {
  name: 'PtSessionMaterial',
  components: {
    Player,
    Confirm,
    Authorsevents
  },
  props: {
    presentations: {
      type: Array,
      default: () => []
    },
    video: {
      type: Object,
      default: () => {}
    },
    material: {
      type: Boolean,
      default: false
    },
    idPlayer: {
      type: String,
      default: ''
    }
  },
  data() {
    const { message, loading, onClickPdf, onClickMultimedia, redirectLogin } =
      useDownLoadMaterial();
    return { message, loading, onClickPdf, onClickMultimedia, redirectLogin };
  },
  mounted() {
    setTimeout(async () => {
      const storageMaterial = localStorageGetObject('material');
      if (storageMaterial) {
        if (storageMaterial.type) {
          await this.onClickPdf(storageMaterial.url, storageMaterial.index, this.material);
        } else {
          await this.onClickMultimedia(storageMaterial.url, storageMaterial.index, this.material);
        }
      }
    }, 2000);
  }
};
</script>
